import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 自定义列组件
 * @author alfielv
 */
import React, { useState, useCallback, useMemo } from 'react';
import _ from 'lodash';
import SpauiColumns from '@tencent/spaui-columns';
import { PREFIX_CLS } from '../../constants';
import OptionMenu from './DropMenu';
import message from '../../components/Message';
import '@tencent/spaui-columns/lib/css/index.css';
import './index.css';
var prefixCls = "".concat(PREFIX_CLS, "-custom-column"); // cellsConfig 映射表

var getCellsConfigMap = function getCellsConfigMap(cellsConfig) {
  var cellsGroupKey = _.keys(cellsConfig); // 生成节点映射


  var getColumnsMap = function getColumnsMap(item) {
    // 下一级并非叶子节点，递归reduce
    if (item.list) {
      return _.reduce(item.list, function (prev, it) {
        return _objectSpread(_objectSpread({}, prev), getColumnsMap(it));
      }, {});
    } // 如果下一级即为叶子节点，直接reduce返回


    return _.reduce(item.columns, function (prev, cur) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cur.name, cur));
    }, {});
  };

  return _.reduce(cellsGroupKey, function (prev, curKey) {
    return _objectSpread(_objectSpread({}, prev), getColumnsMap(cellsConfig[curKey]));
  }, {});
};

export default (function (props) {
  var configureProps = props.configureProps,
      columnsDefs = props.columnsDefs,
      defaultColumns = props.defaultColumns;
  var activeConfigureName = configureProps.activeConfigureName,
      updateActiveConfigureName = configureProps.updateActiveConfigureName,
      originConfigureList = configureProps.originConfigureList,
      updateOriginConfigureList = configureProps.updateOriginConfigureList,
      localConfigure = configureProps.localConfigure,
      updateLocalConfigure = configureProps.updateLocalConfigure;
  var _columnsDefs$cellsCon = columnsDefs.cellsConfig,
      cellsConfig = _columnsDefs$cellsCon === void 0 ? {} : _columnsDefs$cellsCon,
      _columnsDefs$columnsP = columnsDefs.columnsProps,
      columnsProps = _columnsDefs$columnsP === void 0 ? {} : _columnsDefs$columnsP,
      _columnsDefs$dropMenu = columnsDefs.dropMenuProps,
      dropMenuProps = _columnsDefs$dropMenu === void 0 ? {} : _columnsDefs$dropMenu,
      dropMenuTriggerProps = columnsDefs.dropMenuTriggerProps,
      dropMenuTriggerComponent = columnsDefs.dropMenuTriggerComponent;
  var _defaultColumns$unmov = defaultColumns.unmovableCells,
      unmovableCells = _defaultColumns$unmov === void 0 ? [] : _defaultColumns$unmov; // 固定项
  // 当前编辑的配置名，会同步到持久化存储的配置项名称（”保存为常用xxx“的input值）

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      editCfgName = _useState2[0],
      setEditCfgName = _useState2[1]; // 是否展示自定义列配置dialog


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      dialogShow = _useState4[0],
      setDialogShow = _useState4[1]; // 更新远程配置


  var handleOriginConfiguresUpdate = useCallback(function () {
    var storageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeConfigureName;
    var newConfigureList = arguments.length > 1 ? arguments[1] : undefined;
    updateActiveConfigureName(storageName); // 传入最新的configureList再进行更新

    if (newConfigureList) {
      updateOriginConfigureList(newConfigureList);
    }
  }, [activeConfigureName, updateActiveConfigureName, updateOriginConfigureList]); // 更新本地配置

  var handleLocalConfigureUpdate = useCallback(function (newConfigure) {
    updateActiveConfigureName('SESSION_STORAGE');
    updateLocalConfigure === null || updateLocalConfigure === void 0 ? void 0 : updateLocalConfigure(newConfigure);
  }, [updateLocalConfigure, updateActiveConfigureName]); // 常用配置项-删除

  var onDelete = useCallback(function (name) {
    var newCfgs = _.filter(originConfigureList, function (item) {
      return item.name !== name;
    });

    var activeKey = function () {
      // 当前删除项即为激活项，如果列表长度大于1，默认取第一项替代
      if (activeConfigureName === name && newCfgs.length > 0) {
        return newCfgs[0].name;
      } // 否则直接返回，基于沿用当前激活名称


      return;
    }();

    handleOriginConfiguresUpdate(activeKey, newCfgs);
  }, [activeConfigureName, originConfigureList, handleOriginConfiguresUpdate]); // 常用配置项-编辑、"自定义"编辑本地临时数据

  var onEdit = useCallback(function (name) {
    setEditCfgName(name);
    setDialogShow(true);
  }, []); // 提交自定义配置项

  var _onSubmit = useCallback(function (data) {
    var fixed = data.fixed,
        unfixed = data.selected,
        isNeedStorage = data.isNeedStorage,
        storageName = data.storageName; // 排除unmovableCells声明过的纯净fixed

    var pureFixed = _.difference(fixed, unmovableCells); // 排除unmovableCells、fixed声明过的纯净unfixed


    var pureUnfiexed = _.difference(unfixed, [].concat(_toConsumableArray(fixed), _toConsumableArray(unmovableCells))); // 编辑好的新配置


    var newConfigure = {
      name: isNeedStorage ? storageName : 'SESSION_STORAGE',
      unmovableCells: unmovableCells,
      fixed: pureFixed,
      unfixed: pureUnfiexed
    }; // 持久化存储

    if (isNeedStorage && storageName) {
      // 已存在同名配置
      var hasConfigure = _.find(originConfigureList, {
        name: storageName
      }); // 保存为已存在同名，非当前编辑中的同名配置


      if (hasConfigure && storageName !== editCfgName) {
        message.error('已存在同名配置');
        return;
      } // 保存为常用配置并选中


      var _newConfigureList = function () {
        // 名字没变， update当前配置
        if (storageName === editCfgName) {
          return _.map(originConfigureList, function (cfg) {
            return cfg.name === storageName ? _objectSpread(_objectSpread({}, cfg), newConfigure) // 透传原配置项基础上，覆盖newConfigure对应字段
            : cfg;
          });
        } // 否则追加


        return _.concat(originConfigureList, [newConfigure]);
      }();

      handleOriginConfiguresUpdate(storageName, _newConfigureList);
    } else {
      // 直接选中,临时保存到本地
      handleLocalConfigureUpdate(newConfigure);
    }

    setDialogShow(false);
  }, [editCfgName, unmovableCells, originConfigureList, handleOriginConfiguresUpdate, handleLocalConfigureUpdate]); // 当前编辑中的配置


  var editingInitColumns = useMemo(function () {
    // 编辑临时”自定义“
    if (editCfgName === 'SESSION_STORAGE') {
      // 当前激活态为远程数据
      if (activeConfigureName && activeConfigureName !== 'SESSION_STORAGE') {
        var curConfigure = _.find(originConfigureList, {
          name: activeConfigureName
        });

        return curConfigure || defaultColumns;
      } // 当前激活态为本地临时数据


      if (localConfigure && !_.isEmpty(localConfigure)) {
        return localConfigure;
      }

      return defaultColumns;
    } // 编辑远程数据


    if (!!editCfgName) {
      return _.find(originConfigureList, {
        name: editCfgName
      }) || defaultColumns;
    }

    return defaultColumns;
  }, [localConfigure, originConfigureList, editCfgName, defaultColumns, activeConfigureName]);

  var editingFixed = _.get(editingInitColumns, 'fixed', []);

  var editingUnFixed = _.get(editingInitColumns, 'unfixed', []);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls)
  }, /*#__PURE__*/React.createElement(OptionMenu, {
    activeConfigureName: activeConfigureName,
    originConfigureList: originConfigureList,
    dropMenuProps: dropMenuProps,
    onDelete: onDelete,
    onEdit: onEdit,
    onSelect: handleOriginConfiguresUpdate,
    dropMenuTriggerProps: dropMenuTriggerProps,
    dropMenuTriggerComponent: dropMenuTriggerComponent
  }), /*#__PURE__*/React.createElement(SpauiColumns, _extends({
    className: "".concat(prefixCls, "__dialog"),
    checkAll: true,
    storable: true // 是否支持存储
    ,
    storageNameMaxWordNumber: 10 // 存储名称最多几个字符
    ,
    search: true,
    showDirectory: true,
    show: dialogShow,
    onCancel: function onCancel() {
      return setDialogShow(false);
    },
    onSubmit: function onSubmit(data) {
      return _onSubmit(data);
    },
    required: unmovableCells,
    unmovableCells: unmovableCells // 从fixed中排除unmovableCells
    ,
    fixed: _.difference(editingFixed, unmovableCells) // 从unfixed中排除unmovableCells、fixed
    ,
    selected: _.difference(editingUnFixed, [].concat(_toConsumableArray(unmovableCells), _toConsumableArray(editingFixed))),
    cellsConfig: cellsConfig,
    cellsConfigMap: getCellsConfigMap(cellsConfig)
  }, columnsProps, editCfgName !== 'SESSION_STORAGE' && {
    defaultStorageData: {
      checked: editCfgName !== 'SESSION_STORAGE',
      storageName: editCfgName
    }
  })));
});